import { restApi } from '../../api';
import {
  SatisfactionSurveySettings,
  UpdateSatisfactionSurveySettings,
} from './satisfactionSurveySettings.types';

const PATH = 'brands/satisfaction-survey-settings';

export const satisfactionSurveySettingsRepository = {
  get: () => restApi.get<SatisfactionSurveySettings>(PATH),
  update: (body: UpdateSatisfactionSurveySettings) =>
    restApi.patch<SatisfactionSurveySettings>(PATH, body),
};
